import { TemplatePage } from './types';

const adsPromoPromoPage: TemplatePage = {
  header: {
    color: '#C8BCEA',
    icon: 'images/video-templates/promo.jpg',
    title: 'Promo Video Templates Collection',
    title_meta: '400+ Free Editable Promo Video Templates',
    description_meta:
      'Increase brand awareness and get new customers with Wave.video’s collection of 400+ free promo video ' +
      'templates. Easily make promotional videos that convert and sell!',
    description:
      'Increase brand awareness and get new customers with Wave.video’s collection of 400+ free promo video ' +
      'templates. Easily make promotional videos that convert and sell!'
  },
  footer: {
    category: 'promo',
    description:
      'Wave.video’s impressive collection of professionally designed promo video templates helps create ' +
      'attention-grabbing videos fast and hassle-free. All the templates are free and easy to customize to ' +
      'suit your brand and style.'
  },
  content: [
    {
      type: 'templates',
      title: 'Promo Video ',
      search: { category: '/Use Cases/Promotional Videos' }
    },
    {
      type: 'stocks',
      title: 'promo',
      search: { name: 'promo' }
    },
    { type: 'calendar' }
  ]
};

export default adsPromoPromoPage;
